import { useMemo } from 'react';
import { useRecoilValue } from 'recoil';
import useAccountConfig from '@ubeya/shared/hooks/account/useAccountConfig';
import { selectedBranch } from '@ubeya/shared/atoms/shared';
import { filterHolidaysByBranch, groupHolidays } from '@ubeya/shared/utils/scheduling';
import { showAllBranchesMode } from 'shared/atoms/scheduling';

const useGroupedHolidays = ({ branchId, firstDayOfWeek } = {}) => {
  const { account } = useAccountConfig();
  const selectedBranchId = useRecoilValue(selectedBranch);
  const showAllBranches = useRecoilValue(showAllBranchesMode);
  const holidaysBranchId = branchId ?? (showAllBranches ? undefined : selectedBranchId);

  return useMemo(() => groupHolidays(filterHolidaysByBranch(account?.holidays, holidaysBranchId), firstDayOfWeek), [
    account?.holidays,
    holidaysBranchId,
    firstDayOfWeek
  ]);
};

export default useGroupedHolidays;
